var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.83333C5 1.82081 5.82081 1 6.83333 1H14.8089C15.4273 1 16.0041 1.31182 16.3428 1.82929L22.7006 11.5426C22.896 11.841 23 12.19 23 12.5467V21.1667C23 22.1792 22.1792 23 21.1667 23H6.83333C5.82081 23 5 22.1792 5 21.1667V2.83333Z",
    fill: "#002C65"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 18,
    height: 9,
    rx: 1,
    fill: "#48A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66113 12.0234V17H3.63574V12.0234H4.66113ZM6.64355 14.1494V14.9492H4.38086V14.1494H6.64355ZM6.88281 12.0234V12.8267H4.38086V12.0234H6.88281ZM8.56787 12.0234V17H7.5459V12.0234H8.56787ZM12.7275 16.2002V17H10.2222V16.2002H12.7275ZM10.5537 12.0234V17H9.52832V12.0234H10.5537ZM16.6548 16.2002V17H14.0059V16.2002H16.6548ZM14.3408 12.0234V17H13.3154V12.0234H14.3408ZM16.3096 14.0503V14.8296H14.0059V14.0503H16.3096ZM16.6514 12.0234V12.8267H14.0059V12.0234H16.6514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a2fa4b0d388ec34517fa4a51df40a8e2.svg";
export { ForwardRef as ReactComponent };